import React from "react";
import PropTypes from "prop-types";
import { ResultsTable } from "@components/ResultsTable/ResultsTable";
import TotalFineDisplay from "./TotalFineDisplay";
import OverdueBooksCount from "./OverdueBooksCount";
import BookDetailsDisplay from "../FeeDisplay/BookDetailsDisplay";
import ActionButtons from "./ActionButtons";
import ViewDetailsButton from "../FeeDisplay/ViewDetailsButton";

const FineManagementTable = ({
  data,
  urlLoanId,
  onPayFine,
  onOverdueSlip,
  onViewPaymentHistory,
}) => {
  const getUserType = (row) => {
    if (row.user_type) {
      return row.user_type.trim().toLowerCase();
    }
    if (row.role) {
      return row.role.trim().toLowerCase();
    }
    return "student";
  };

  const viewDetailsFormatter = ({ row }) => {
    const userType = getUserType(row);
    return <ViewDetailsButton patronId={row.pid} userType={userType} />;
  };
  viewDetailsFormatter.propTypes = {
    row: PropTypes.object.isRequired,
  };

  const totalFineFormatter = ({ row }) => (
    <TotalFineDisplay totalFine={row.totalFine} loans={row.loans} />
  );
  totalFineFormatter.propTypes = {
    row: PropTypes.object.isRequired,
  };

  const overdueBooksFormatter = ({ row }) => (
    <OverdueBooksCount overdueCount={row.overdueCount} />
  );
  overdueBooksFormatter.propTypes = {
    row: PropTypes.object.isRequired,
  };

  const bookDetailsFormatter = ({ row }) => (
    <div className="book-details-column">
      {row.loans && row.loans.length > 0 ? (
        <BookDetailsDisplay loans={row.loans} urlLoanId={urlLoanId} />
      ) : (
        <div style={{ fontStyle: "italic", color: "#666" }}>
          No active overdue loans
        </div>
      )}
    </div>
  );
  bookDetailsFormatter.propTypes = {
    row: PropTypes.object.isRequired,
  };

  const actionsFormatter = ({ row }) => (
    <div className="actions-column">
      {row.loans && row.loans.length > 0 ? (
        <ActionButtons
          patron={row}
          onPayFine={onPayFine}
          onOverdueSlip={onOverdueSlip}
          onViewPaymentHistory={onViewPaymentHistory}
        />
      ) : (
        <div style={{ fontStyle: "italic", color: "#666" }}>
          No actions available
        </div>
      )}
    </div>
  );
  actionsFormatter.propTypes = {
    row: PropTypes.object.isRequired,
  };

  const columns = [
    {
      title: "Type",
      field: "user_type",
      formatter: viewDetailsFormatter,
    },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    {
      title: "Total Fine",
      field: "totalFine",
      formatter: totalFineFormatter,
    },
    {
      title: "Overdue Books",
      field: "overdueCount",
      formatter: overdueBooksFormatter,
    },
    {
      title: "Book Details",
      field: "",
      formatter: bookDetailsFormatter,
    },
    {
      title: "Actions",
      field: "",
      formatter: actionsFormatter,
    },
  ];

  return (
    <div className="fine-management-container" style={{ overflowX: "auto" }}>
      <ResultsTable
        data={data.hits}
        columns={columns}
        totalHitsCount={data.total}
        title="Fine Management"
        subtitle="Patrons with overdue books."
        name="patrons with overdue books."
      />
    </div>
  );
};

FineManagementTable.propTypes = {
  data: PropTypes.shape({
    hits: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  urlLoanId: PropTypes.string,
  onPayFine: PropTypes.func.isRequired,
  onOverdueSlip: PropTypes.func.isRequired,
  onViewPaymentHistory: PropTypes.func.isRequired,
};

FineManagementTable.defaultProps = {
  urlLoanId: null,
};

export default FineManagementTable;
